const mql = window.matchMedia('screen and (max-width: 768px)');
const UnicoUtils = {
  isPC: () => !(mql.matches),
  isSP: () => mql.matches,
  mql: mql
};

document.addEventListener("DOMContentLoaded", () => {
    unico_cprt_header();
    unico_cprt_menu();
    if (UnicoUtils.isPC()) {
        unico_cprt_topSlider();
    }
});

function unico_cprt_topSlider() {
    const target = document.querySelector('.unico-cprt-top-case');
    if (target) {
        const swiper = new Swiper('.unico-cprt-top-case .swiper', {
                loop: true,
                speed: 700,
                slidesPerView: 'auto',
                loopedSlides:8,
                spaceBetween: 20,
                autoplay: {
                    delay: 2000,
                    pauseOnMouseEnter: true,
                },
                pagination: false,
                navigation: false,
            });
    }
}

function unico_cprt_header() {
    const body = document.querySelector('body');
    const headerElem = document.querySelector('.unico-cprt-header');

    const fixedHeader = () => {
      const headerHeight = headerElem.clientHeight;
      if (window.scrollY >= headerHeight) {
        body.style.marginTop = `${headerElem.clientHeight}px`;
        headerElem.style.top = `-${headerElem.clientHeight}px`;
        headerElem.classList.add('--is-fixed');
      } else {
        headerElem.style.top = 'auto';
        headerElem.classList.remove('--is-fixed');
        body.style.marginTop = `0px`;
      }
    }
    window.addEventListener('scroll', fixedHeader);
    window.addEventListener('resize', fixedHeader);
}

function unico_cprt_menu() {
    const body = document.querySelector('body');
    const menuButton = document.querySelector('.unico-cprt-header-button');
    const menu = document.querySelector('.unico-cprt-header-menu');
    const menuArea = document.querySelector('.unico-cprt-header-menu__inner');
    
    menuButton.addEventListener("click", () => {
      menu.classList.toggle("--is-active");
      menuButton.classList.toggle("--is-active");
      if (menu.classList.contains('--is-active')) {
        body.style.overflow = "hidden"
      } else {
        body.style.overflow = "auto"
      }
    });

    document.addEventListener("click", (e) => {
      if (menu.classList.contains("--is-active") && !menuArea.contains(e.target) && !menuButton.contains(e.target)) {
        menu.classList.remove("--is-active");
        menuButton.classList.toggle("--is-active");
        body.style.overflow = "auto";
      }
    }, true);
}